import {createApp} from 'vue';
import StatisticsView from './StatisticsView';
import {createBootstrap} from 'bootstrap-vue-next'
import {VueDraggable} from 'vue-draggable-plus'

$(document).ready(/\/student-management\/statistics$/.test(window.location.pathname)&&function() {
    const container = $('#statistics-container');

    createApp(StatisticsView, container.data())
        .use(createBootstrap())
        .component('Draggable', VueDraggable)
        .mount(container[0]);
});
